// extracted by mini-css-extract-plugin
export default {"image":"device_image__rbPRD","deviceAdd":"device_deviceAdd__XR4LS","text":"device_text__wjAST","deviceModal":"device_deviceModal__FblUX"};